import { apiFetch, parseJson } from "./client";
import type { CatalogItem, Variety } from "./types";

export async function getTechnologies(): Promise<CatalogItem[]> {
  return parseJson<CatalogItem[]>(await apiFetch("/api/technologies"));
}

export async function getAdvancedTechnologies(): Promise<CatalogItem[]> {
  return parseJson<CatalogItem[]>(await apiFetch("/api/advanced-technologies"));
}

export async function getCrops(): Promise<CatalogItem[]> {
  return parseJson<CatalogItem[]>(await apiFetch("/api/crops"));
}

export async function getVarieties(cropId: string | null): Promise<Variety[]> {
  const query = cropId
    ? `?${new URLSearchParams({ crop_id: cropId }).toString()}`
    : "";
  return parseJson<Variety[]>(await apiFetch(`/api/varieties${query}`));
}

export async function getFleetTechnologies(): Promise<CatalogItem[]> {
  return parseJson<CatalogItem[]>(await apiFetch("/api/fleet-technologies"));
}

export async function searchSupportMaterials(
  q: string
): Promise<CatalogItem[]> {
  return parseJson<CatalogItem[]>(
    await apiFetch(
      `/api/support-materials?${new URLSearchParams({ q }).toString()}`
    )
  );
}
